import {PageRouteProvider} from "@reapptor-apps/reapptor-react-common";
import {CalendarEvent} from "@/models/server/CalendarEvent";
import {VibrationEvent} from "@/models/server/VibrationEvent";

type TPostMessageHandler = (message: string) => void;

interface IPostMessageListener {
    postMessage: TPostMessageHandler;
}

class NativeController {
    
    private get postMessageListener(): IPostMessageListener | null {
        const webKit: any | null = (window as any).webkit;
        const postMessageListener: any | null = webKit?.messageHandlers?.postMessageListener;
        return (typeof postMessageListener?.postMessage === "function")
            ? postMessageListener
            : null;
    }
    
    private async invokeMessageAsync(message: string): Promise<void> {
        const postMessageListener: IPostMessageListener | null = this.postMessageListener;
        if (postMessageListener) {
            try {
                postMessageListener.postMessage(message);
            } catch (e) {
                await PageRouteProvider.exception(e as Error);
            }
        }
    }
    
    public async publishCalendarEventAsync(event: CalendarEvent): Promise<void> {
        const message: string = JSON.stringify(event);
        await this.invokeMessageAsync(message);
    }
    
    public async vibrateAsync(): Promise<void> {
        
        const vibrate: any | null = (navigator as any).vibrate;
        if (typeof vibrate === "function") {
            if (vibrate.call(navigator, 200)) {
                return;
            }
        }
        
        const event = new VibrationEvent();
        const message: string = JSON.stringify(event);
        await this.invokeMessageAsync(message);
    }
}

//Singleton
export default new NativeController();